import { render, staticRenderFns } from "./ProductOrder.vue?vue&type=template&id=caac7536&scoped=true&"
import script from "./ProductOrder.vue?vue&type=script&lang=js&"
export * from "./ProductOrder.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrder.vue?vue&type=style&index=0&id=caac7536&lang=scss&scoped=true&"
import style1 from "./ProductOrder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caac7536",
  null
  
)

export default component.exports